module.exports = __webpack_public_path__ + "img/logo-cvpc-branco.254ad74b.png";